import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Row } from 'react-grid-system'
import Tag from '../../commons/Tag/Tag'

const PeopleFilters = ({ handlerFilter }) => {
  const [current, setCurrent] = useState(null)

  const changeFilter = useCallback(
    (status = null) => {
      setCurrent(status)
      handlerFilter(status)
    },
    [setCurrent, handlerFilter]
  )

  return (
    <Row style={{ paddingTop: 16, paddingBottom: 16 }}>
      <Tag
        white
        width="140px"
        text="Todos"
        active={current === null}
        onClick={() => changeFilter(null)}
      />
      <Tag
        white
        width="140px"
        text="Ativos"
        active={current === 7}
        onClick={() => changeFilter(7)}
      />
      <Tag
        white
        width="140px"
        text="Pendentes"
        active={current === 9}
        onClick={() => changeFilter(9)}
      />
    </Row>
  )
}

PeopleFilters.propTypes = {
  handlerFilter: PropTypes.func.isRequired
}

export default PeopleFilters
